import React, { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import { resolveStorageDisplayUrl } from "../../utils/uploadResponseUtils";

interface SocialAvatarProps {
  src?: string | null;
  name?: string;
  size?: number;
  className?: string;
  userType?: "HOSPITAL" | "DOCTOR" | string;
}

const SocialAvatar: React.FC<SocialAvatarProps> = ({
  src,
  name,
  size = 48,
  className = "",
  userType,
}) => {
  const [failed, setFailed] = useState(false);
  const label = name?.trim() || "Hospital";
  const initial = label.charAt(0).toUpperCase();
  const resolved = resolveStorageDisplayUrl(src, undefined, { inline: true });
  const showImage = Boolean(resolved) && !failed;

  useEffect(() => {
    setFailed(false);
  }, [resolved]);

  if (showImage) {
    return (
      <img
        key={resolved}
        src={resolved}
        alt={label}
        width={size}
        height={size}
        style={{ width: size, height: size, minWidth: size, minHeight: size }}
        className={`rounded-full object-contain object-center bg-neutral-100 shrink-0 ring-2 ring-white shadow-sm ${className}`}
        onError={() => setFailed(true)}
      />
    );
  }

  const isHospital = userType === "HOSPITAL" || userType === "SYSTEM";

  return (
    <div
      className={`rounded-full shrink-0 flex items-center justify-center font-semibold text-white ring-2 ring-white shadow-sm ${className}`}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(12, size * 0.38),
        background: isHospital
          ? "linear-gradient(135deg, #E4B56A 0%, #C48A3A 100%)"
          : "linear-gradient(135deg, #6366f1 0%, #7c3aed 100%)",
      }}
      title={label}
    >
      {isHospital ? (
        <Building2 size={Math.max(16, size * 0.42)} />
      ) : (
        initial
      )}
    </div>
  );
};

export default SocialAvatar;
